import Footer from '@/components/footer'
import RE from '@/assets/replace.js'
import { myHTTP } from '@/utils/net'
import { lang } from '@/tool/lang'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}
export default {
    components: {
        Footer,
    },
    props: ['language'],
    data() {
        return {
            RE,
            isModal: 0,
            verificationCode: '',
            userId: '',
            redemption: '',
            verification: '',
            isClick: false,
            captchaId: '',
            message: '',
            newArr: [{}],
            isBooked: false,
            options: RE.options,
        }
    },
    computed: {
        isDisable() {
            return this.userId !== '' && this.redemption !== '' && this.verification !== '';
        },
        getLabel() {
            const matchedOption = this.options.find(option => option.value === this.language);
            return matchedOption ? matchedOption.label : '';
        }
    },
    watch: {
        isModal(newValue) {
            if (newValue > 0) {
                this.stop();
            } else {
                this.move();
            }
        }
    },
    mounted() {
        this.getLang(this.language);
        this.getId();
        if (parsed.code) {
            this.redemption = parsed.code
        }
    },
    methods: {
        handleClick(val){
            this.$emit('handleLang', val);
            this.isBooked = false;
            this.getLang(val);
        },
        getLang(language) {
            for (var i in lang) {
                this.newArr[0][i] = lang[i][language]
            }
        },
        scrollToTop() {
            const moRootElement = this.$refs.mo_root;
            if (moRootElement) {
                moRootElement.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Smooth scrolling
                });
            } else {
                console.error('mo_root element not found');
            }
        },
        //禁止页面滑动
        stop() {
            var mo = function (e) {
                passive: false
            }
            document.body.style.overflow = 'hidden'
            document.addEventListener('touchmove', mo, false) //禁止页面滑动
        },
        //取消滚动限制
        move() {
            var mo = function (e) {
                passive: false
            }
            document.body.style.overflow = '' //出现滚动条
            document.removeEventListener('touchmove', mo, false)
        },
        getId() {
            myHTTP.post('/api/v1/captcha/generate').then(res => {
                this.captchaId = res.data.data.captchaId
                myHTTP.get(`/api/v1/captcha/image/${res.data.data.captchaId}`).then(res => {
                    this.verificationCode = res.config.url
                    this.isClick = true
                })
            })
        },
        refresh() {
            if (this.isClick) {
                this.isClick = false
                this.getId()
            }
        },
        handleYes() {
            this.claim()
            this.isModal = 0
        },
        handleOk() {
            this.isModal = 0
            this.getId()
        },
        claim() {
            let aclaim = ''
            if (this.userId.indexOf('-') !== -1) {
                aclaim = this.userId.split('-')[1].replace(/^\s+|\s+$/gm, '')
            } else {
                aclaim = this.userId.replace(/^\s+|\s+$/gm, '')
            }
            myHTTP
                .post('/api/v1/giftcode/claim', {
                    userId: aclaim,
                    giftCode: this.redemption.replace(/^\s+|\s+$/gm, ''),
                    captcha: this.verification.replace(/^\s+|\s+$/gm, ''),
                    captchaId: this.captchaId.replace(/^\s+|\s+$/gm, '')
                })
                .then(res => {
                    console.log(res, res.data.code, 'res')
                    this.isModal = 4
                    let code = res.data.code
                    if (code === 0) {
                        this.message = this.newArr[0][21]
                    } else if (code === 20001) {
                        this.message = this.newArr[0][22]
                    } else if (code === 20002) {
                        this.message = this.newArr[0][23]
                    } else if (code === 20003) {
                        this.message = this.newArr[0][24]
                    } else if (code === 20401) {
                        this.message = this.newArr[0][25]
                    } else if (code === 20402) {
                        this.message = this.newArr[0][26]
                    } else if (code === 20403) {
                        this.message = this.newArr[0][27]
                    } else if (code === 20404) {
                        this.message = this.newArr[0][28]
                    } else if (code === 20407) {
                        this.message = this.newArr[0][29]
                    } else if (code === 20409) {
                        this.message = this.newArr[0][30]
                    } else if (code === 20410) {
                        this.message = this.newArr[0][31]
                    } else if (code === 30001) {
                        this.message = this.newArr[0][32]
                    } else {
                        this.message = this.newArr[0][32] + '(' + code + ')'
                    }
                })
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/index.js